(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("child_process"), (function webpackLoadOptionalExternalModule() { try { return require("pandoc-wasm"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define("LegalMarkdown", ["child_process", "pandoc-wasm"], factory);
	else if(typeof exports === 'object')
		exports["LegalMarkdown"] = factory(require("child_process"), (function webpackLoadOptionalExternalModule() { try { return require("pandoc-wasm"); } catch(e) {} }()));
	else
		root["LegalMarkdown"] = factory(root["child_process"], root["pandoc-wasm"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__660__, __WEBPACK_EXTERNAL_MODULE__162__) => {
return 